import { render, staticRenderFns } from "./ContactInfoForm.vue?vue&type=template&id=709c6c16&scoped=true&"
import script from "./ContactInfoForm.vue?vue&type=script&lang=js&"
export * from "./ContactInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoForm.vue?vue&type=style&index=0&id=709c6c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709c6c16",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
